export default {
    global: {
        close : 'zamknąć',
        save : 'Zapisać',
        continue : 'Kontynuować',
        confirmAndSend : 'Potwierdź i wyślij',
        mandatory_field : 'To pole jest wymagane',
        checkbox_mandatory : 'To pole wyboru jest wymagane',
        cancel : 'Anuluj',
        ok : 'Dobrze',
        yes : 'Tak',
        no : 'Nie',
        post_success : 'Dane wysłane dobrze',
        code : 'KOD:'
    },
    menu:{
        main_menu : 'Menu główne',
        lmra : 'Otwarte/Zamknięte LMRA',
        report_incident: 'Zgłoś incydent',
        report_near_incident : 'Zgłoś bliski incydent',
        risk_analysis : 'Ocena ryzyka',
        corona_analysis : 'Analiza koronowa',
        scan_qr : "Zeskanuj kod TAG / QR",
        process_issue : "Zgłoś problem z procesem",
        checklist : "Zobacz listę kontrolną",
        log_in: "Zaloguj się",
        log_out : "Wyloguj się",
        emergency_numbers : "Numery alarmowe"
    },
    default_lrma: {
        what_label : 'Czy rozumiem co robić?',
        how_label : 'Czy wiem jak to zrobić?',
        risks_label : 'Czy dostrzegam niebezpieczeństwa i ryzyko?',
        control_label : 'Czy mogę to kontrolować?',
        default_pbm_label : 'Czy mam odpowiednie ŚOI?',
        default_pbm_question : 'Czy mam odpowiednie ŚOI?|1',
        lmra_job_state_positive : 'Ok, aby rozpocząć pracę, przejrzymy LMRA, gdy wystąpią zmiany',
        lmra_job_state_negative : 'Nie rozpoczynamy jeszcze pracy.',
    },
    static_three_state_lmra : {
        getting_data_title : "Trwa pobieranie najnowszej wersji.",
        could_not_load_newest_list_title : 'Uwaga',
        could_not_load_newest_list : 'Podczas pobierania najnowszej listy wystąpił błąd. Wyświetlona zostanie starsza zapisana wersja listy, aby można było kontynuować. Jeśli problem będzie się powtarzał, najlepiej poinformować o tym odpowiedzialną osobę.',
    },
    private_location : {
        title : 'Czy jesteś w prywatnej lokalizacji?',
        body : 'Lokalizacje prywatne to lokalizacje poza miejscami związanymi z pracą.'
    },
    remarks:{
        remarksDialogTitle : 'Uwagi?',
        remarksDialogPlaceholder: 'Wpisz tutaj swoje uwagi',
    },
    start_stop_screen :{
        start_work_btn : "rozpocząć pracę",
        stop_work_btn : "przestać działać",
    },
    work_report : {
        title : "Raport pracy",
        placeholder : "Wpisz tutaj raport z pracy",
        skip_work_report : "Pominąć",
        buildingListTitle : "Tworzymy formularz raportu z pracy, nie powinno to zająć zbyt długo.",
        criticalErrorTitle: 'błąd:',
        criticalErrorBody: 'Coś poszło nie tak podczas tworzenia formularza raportu z pracy! Podaj swojemu menadżerowi poniższy kod błędu:',
    },
    incident_report: {
        title: "Zgłoś incydent",
        placeholder : "Co się stało?",
    },
    oeps_report:{
        title: "Zgłoś blisko incydentu",
        placeholders : {
            machine : 'Która maszyna?',
            who : 'Kto był zaangażowany?',
            what : 'Co się stało?',
            how : 'Jak to się stało / jak to się stało?',
            stop_card : 'Wybierz Stopcard',
            location: 'Wybierz lokalizację',
            department: 'Wybierz dział'
        },
        external_employee : 'Jest pracownikiem zewnętrznym',
        when_text_label : 'Kiedy to się stało?',
        change_date_time_btn : 'Zmień datę / godzinę'
    },
    risk_analysis:{
        title: {
            risk_default : "Ocena ryzyka",
            risk_default_sub_title: '',
            corona: "Analiza koronowa",
            corona_sub_title: 'Wskaż poniżej swoje warunki pracy i dowiedz się, jak bezpiecznie pracować.'
        },
        lists :{
            risk_default : {
                gravity :{
                    label: 'Powaga' ,
                    gravity_01 : 'niewielkie obrażenia bez absencji',
                    gravity_02 : 'ważne obrażenia i nieobecności',
                    gravity_07 : 'ciężka, trwała niepełnosprawność / stany przewlekłe z (częściową) niezdolnością do pracy',
                    gravity_15 : 'bardzo poważny, 1 martwy (ostry w dłuższej perspektywie)',
                    gravity_40 : 'katastrofa, liczne zgony'
                },
                probability :{
                    label: 'Prawdopodobieństwo' ,
                    probability_0_1 : 'prawie niemożliwe do wyobrażenia',
                    probability_0_2 : 'praktycznie niemożliwe',
                    probability_0_5 : 'możliwe do wyobrażenia, ale mało prawdopodobne',
                    probability_01 : 'mało prawdopodobne, sprawa z pogranicza',
                    probability_03 : 'niezwykłe, ale możliwe',
                    probability_06 : 'całkiem możliwe',
                    probability_10 : 'spodziewany'
                },
                exposure : {
                    label : 'Narażenie',
                    exposure_0_5 : 'bardzo rzadko (1x rocznie)',
                    exposure_01 : 'rzadko (raz w roku)',
                    exposure_02 : 'czasami (co miesiąc)',
                    exposure_03 : 'okazjonalnie (co tydzień)',
                    exposure_06 : 'regularnie (codziennie)',
                    exposure_10 : 'stale',
                },
            },
            corona : {
                distance :{
                    label: 'Oczekiwana odległość między mną a innymi osobami:' ,
                    distance_01 : 'D > 8 m',
                    distance_02 : '6 m < D < 8 m',
                    distance_07 : '2 m < D < 6 m',
                    distance_15 : '1,5 m < D < 2 m',
                    distance_40 : '1 m < D < 1,5 m',
                    distance_100 : 'D < 1 m'
                },
                probability :{
                    label: 'Zauważam, że inni ...' ,
                    probability_0_1 : 'nosić maskę FFP2 + okulary ochronne i odzież ochronną',
                    probability_0_2 : 'nosić maskę FFP2 + okulary',
                    probability_0_5 : 'nosić maskę lub osłonę twarzy',
                    probability_01 : 'zdecydowanie przestrzegaj Wytycznych Korony',
                    probability_03 : 'być może przestrzegać Wytycznych Korony',
                    probability_06 : 'naruszać niektóre wytyczne dotyczące koronowania',
                    probability_10 : 'Naruszono wiele wytycznych dotyczących koronowania'
                },
                exposure : {
                    label : 'Szansa na bliższy kontakt niż oczekiwano:',
                    exposure_0_5 : 'Bardzo mało prawdopodobne',
                    exposure_01 : 'Gdy kilka rzeczy pójdzie nie tak',
                    exposure_02 : 'Niezwykłe, jeśli pewne rzeczy pójdą nie tak',
                    exposure_03 : 'Możliwe, że szanse nie są tak duże',
                    exposure_06 : 'Całkiem możliwa, rozsądna szansa',
                    exposure_10 : 'Można się tego spodziewać, prawie na pewno',
                },
            },
        },
        results: {
            risk_default : {
                kinneyCode1 : 'Żaden',
                kinneyCode2 : 'wymaga uwagi',
                kinneyCode3 : 'wymagane środki można zaplanować',
                kinneyCode4 : 'natychmiastowa poprawa',
                kinneyCode5 : 'przestać działać'
            },
            corona :{
                kinneyCode1 : 'Dopuszczalne ryzyko: nie są wymagane dodatkowe środki ochronne',
                kinneyCode2 : 'Możliwe ryzyko: wymaga uwagi',
                kinneyCode3 : 'Poważne ryzyko: Podejmij środki ochronne',
                kinneyCode4 : 'Wysokie ryzyko: Podejmij zwiększone środki ochronne',
                kinneyCode5 : 'Bardzo wysokie ryzyko: spróbuj dostosować aktywność, jeśli to niemożliwe, podejmij maksymalne środki ochronne'
            },
        },
        supportive_texts : {
            risk_default : {
                supportiveText1 : '',
                supportiveText2 : '',
                supportiveText3 : '',
                supportiveText4 : '',
                supportiveText5 : ''
            },
            corona : {
                supportiveText1 : 'Znam i przestrzegam Wytycznych Corona, które mają zastosowanie w moim środowisku pracy.',
                supportiveText2 : 'Znam i przestrzegam obowiązujących wytycznych Corona. Wyraźnie proszę ludzi w moim środowisku pracy, aby przestrzegali również wytycznych Corona. Nie są wymagane żadne dodatkowe środki ochronne.',
                supportiveText3 : 'Byłem lub zdezynfekowałem ręce na początku i na końcu aktywności. Noszę osłonę twarzy lub odpowiednią maskę na usta w połączeniu z (bezpiecznymi) okularami. Ludzie w moim środowisku pracy muszą przynajmniej nosić osłonę twarzy lub maskę na nos (najlepiej razem z okularami ochronnymi). Wiem, jak prawidłowo korzystać z tych środków ochrony zbiorowej i stosować je w praktyce. Znam i szanuję obowiązujące Wytyczne Corona i wyraźnie proszę ludzi w moim środowisku pracy, aby przestrzegali również Wytycznych Corona.',
                supportiveText4 : 'Byłem lub zdezynfekowałem ręce na początku i na końcu aktywności oraz po każdym niebezpiecznym dotknięciu. Noszę ochronną maskę na nos (najlepiej maskę ochronną dróg oddechowych FFP2) w połączeniu z osłoną twarzy lub goglami. Wiem, jak prawidłowo używać tych środków ochrony osobistej (PPE) i stosować je w praktyce. Znam wytyczne dotyczące koronowania, które mają zastosowanie w środowisku pracy i oczywiście nadal przestrzegam tych wytycznych. Proszę ludzi w moim środowisku pracy, aby podjęli również niezbędne środki bezpieczeństwa i przestrzegali wytycznych Corona.',
                supportiveText5 : 'Najpierw zastanawiam się, czy działalność można przeprowadzić w inny sposób bez bezpośredniego kontaktu z innymi osobami. Jeśli nie będzie to możliwe, podejmę wszelkie możliwe środki bezpieczeństwa. Byłem lub zdezynfekowałem ręce na początku i na końcu aktywności. Noszę rękawice ochronne. Noszę maskę ochronną dróg oddechowych (przynajmniej FFP2) w połączeniu z osłoną twarzy lub okularami ochronnymi i odzieżą ochronną. Wiem, jak prawidłowo używać tych środków ochrony osobistej (PPE) i stosować je w praktyce. Znam wytyczne dotyczące koronowania, które obowiązują w środowisku pracy i oczywiście nadal przestrzegam tych wytycznych. Proszę ludzi w moim środowisku pracy, aby również podjęły niezbędne środki bezpieczeństwa i uważnie przestrzegały tych wytycznych.'
            }
        },
        leave_warning : {
            risk_default : {
                title : 'Uwaga',
                body : 'Zamierzasz zamknąć to okno bez wysyłania bieżącego raportu z analizy ryzyka. Czy na pewno chcesz opuścić stronę?'
            },
            corona : {
                title : 'Uwaga',
                body : 'Zamierzasz zamknąć to okno bez wysyłania bieżącego raportu z analizy koronowej. Czy na pewno chcesz opuścić stronę?'
            }
        },
        report_title : 'Raport z analizy',
        placeholder_report : 'Opisz / wyjaśnij sytuację'
    },
    process_issue:{
        title: "Zgłoś problem z procesem",
        placeholders :{
            issue_type_select: 'Wybierz typ problemu',
            failure_detail: 'Wybierz szczegóły problemu',
            who : 'Kto był zaangażowany?',
            description : 'Opisz problem',
            cnf : 'CNF?',
            comment : 'Dodatkowe uwagi / komentarze',
            other : 'Inne'
        }
    },
    checklist: {
        getting_data_title : "Najnowsza lista kontrolna jest gromadzona."
    },
    data_transfer : {
        post_busy : 'Proszę czekać, dane są wysyłane.',
        post_success : 'Dane zostały dobrze wysłane.'
    },
    gdpr_disclaimer : {
        title: 'Propozycja RODO:',
        body: 'Przesłanie elementu aplikacji lmra-first następujące dane zostaną zapisane w bazie danych: aktualna lokalizacja (GPS - współrzędne (po potwierdzeniu)) i dokładny czas (i tylko w tym czasie). Żadna z tych pozycji nie będzie sprzedawana innym stronom, organizacjom. Przechowywane dane będą wykorzystywane tylko w kolejności projektu i powiązanych warunków pracy',
        accept_btn : 'Akceptuję',
        decline_btn : 'Opuść aplikację'
    },
    data_notice: {
        button_text: 'Co dzieje się z tymi informacjami?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings : {
        alert_cn_pid_nf_title : 'Ups wygląda na to, że o czymś zapomniałeś:',
        alert_cn_pid_nf_body : 'Nazwa klienta i / lub identyfikator projektu nie są wypełnione, sprawdź wartości',
        client_select_placeholder : 'Wybierz klienta',
        project_select_placeholder : 'Wybierz projekt',
        client_not_in_list_label : 'Klienta nie ma na liście',
        project_not_in_list_label : 'projekt nie na liście',
        client_name : 'Nazwa klienta',
        project_id : 'Identyfikator projektu',
        project_distance : 'Odległość projektu',
        project_shift : 'Projekt Shift',
        user_initials : 'Twoje inicjały',
        project_tag_code_label : 'Kod TAG projektu',
        warning : {
            intro : 'Używasz teraz ręcznego wprowadzania dla',
            reason_server :'ponieważ nie można załadować danych serwera!',
            reason_client_not_listed :'ponieważ klienta nie ma na aktualnej liście!',
            reason_project_not_listed :'ponieważ projektu nie ma na aktualnej liście!',
            dbl_check : 'Przed zapisaniem sprawdź dokładnie wszystkie wartości!',
            admin_msg : 'Jeśli ten komunikat nadal się pojawia, skontaktuj się z administratorem i zgłoś to!'
        },
        input_errors : {
            no_client_selected : 'Wybierz klienta',
            no_project_selected : 'Wybierz projekt',
        },
        loading_cap : 'Ładowanie danych z serwera',
        custom_shifts_labels: {
            open_field : 'Otwarte pole'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Błąd skanowania",
                body : "Wykryto nieprawidłowy format danych QR"
            },
            error_popup_notice_manual_mode : {
                title : "Coś poszło nie tak",
                body : "Coś poszło nie tak podczas ładowania danych RRQRCode i przełączania do trybu ręcznego"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Ładowanie strumienia z kamery ...',
            default_error_button_test: 'Zakończ'
        },
        overlay_view: {
            tytuł: 'Skanuj TAG - Kod',
            info_manual: 'Masz problemy ze skanowaniem? Użyj wprowadzania ręcznego ',
            manual_btn: 'Włącz ręczne wprowadzanie.',
            błędy: {
                invalid_tag_title: 'Nieprawidłowy TAG-CODE',
                invalid_tag_body: 'Zeskanowany kod nie jest prawidłowym TAG-CODE, zeskanuj poprawny TAG-CODE lub przełącz na ręczne wprowadzanie.',
                error_btn_txt: 'Włącz ręczne wprowadzanie'
            }
        }
    },
    errors:{
        checklistNotLoaded : 'Podczas pobierania listy wystąpił błąd. Spróbuj ponownie później.',
        EmergencyNumbersOverviewNotLoaded: 'Podczas pobierania listy wystąpił błąd. Spróbuj ponownie później.',
        missing_critical_resource_title : 'Błąd ładowania danych:',
        missing_critical_resource : 'Brak aplikacji w aplikacji. Zgłoś poniższy kod administratorowi.',
        app_corrupt : 'Wygląda na to, że konfiguracja aplikacji jest uszkodzona. Skontaktuj się z administratorem.',
        data_save_failed : 'Nie można wysłać danych, spróbuj ponownie później ...',
        camera: {
            NotAllowedError : 'BŁĄD: Musisz udzielić zgody na dostęp do kamery',
            NotFoundError : 'BŁĄD: brak kamery na tym urządzeniu',
            NotSupportedError : 'BŁĄD: wymagany bezpieczny kontekst (HTTPS, localhost)',
            NotReadableError : 'BŁĄD: czy kamera jest już używana?',
            OverconstrainedError : 'BŁĄD: Zainstalowane kamery nie są odpowiednie',
            StreamApiNotSupportedError : 'BŁĄD: interfejs API Stream nie jest obsługiwany w tej przeglądarce',
        },
        no_internet : 'Ups ... jesteś offline, sprawdź swoje połączenie internetowe!',
        input_validation : {
            char_limit : 'Dozwolonych jest maksymalnie %n znaków'
        },
        auth0 :{
            unverified_email : {
                error: 'Błąd: adres e-mail nie został zweryfikowany! Sprawdź swój email!',
                info : 'Aby uzyskać dostęp do tej aplikacji <b>musisz zweryfikować swój adres e-mail</b>.<br/><br/>Wkrótce <b>otrzymasz wiadomość e-mail</b> <b >od |SENDER| </b><br/><br/><i>Aby zweryfikować swój adres e-mail. Postępuj zgodnie z instrukcjami w e-mailu</i>'
            }
        }
    },
    noDataText: "Dane nie dostępne ...",
    defaultDynamicQuestion : '{"dynamic_questions":[{"id":null,"question":"Czy mam odpowiednie ŚOI?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-mail',
        passwordLabel : 'Hasło',
        rememberMeLabel : "Zapamiętaj mnie",
        logInBtn: "Zaloguj się",
        logOutBtn: "Wyloguj się",
        verifyMFABtn : "Zweryfikuj",
        errorPopupTitle : "Błąd",
        confirmIdentify : "Wciąż Ty?",
        errors :{
            required : "Wymagane",
            invalidEmail : "Nieprawidłowy e-mail",
            unknownError : "Wystąpił nieznany błąd"
        },
        registerNewAccountBtn : "Utwórz nowe konto.",
        forgotPassword : "Nie pamiętam hasła"
    },
    lmraComponent : {
        loadingProjectData : 'Przygotowuję formularz LMRA, proszę czekać',
        startWorkQrDialog:{
            title : "Wybierz metodę uruchomienia:",
            body : "Jeśli masz kod QR Risk-reflex, wybierz kod QR, w przeciwnym razie użyj metody wprowadzania ręcznego",
            positive_btn : "Kod QR",
            negative_btn : "Metoda ręczna"
        },
        errors : {
            unknownError : "Wystąpił nieznany błąd",
            noListDataFound : "Błąd: NIE ZNALEZIONO DANYCH LISTY!! POWRÓT DO DOMYŚLNEGO LMRA",
            noDefaultListFound: 'Brak dostępnej listy domyślnej! Korzystanie z DOMYŚLNEGO LMRA!',
        }
    },
    customLmraLists : {
        buildingListTitle : "Tworzenie formularza LMRA nie powinno zająć dużo czasu.",
        criticalErrorTitle: 'Błąd:',
        criticalErrorBody: "Coś poszło nie tak podczas tworzenia formularza LMRA! Teraz załadujemy domyślny LMRA! podaj swojemu kierownikowi poniższy kod błędu: ",
    },
    workSessions :{
        global : {
            expiredLabel : "Wygasła"
        },
        resumeSessionDialog : {
            titleActiveSession : "Znaleziono aktywną sesję",
            titleActiveSessionExpired : "(Wygasła) znaleziona aktywna sesja",
        },
        workSessionServiceNaDialog :{
            title : "USŁUGA SESJI ROBOCZEJ NIEDOSTĘPNA",
            body : "Przepraszamy, nie możemy określić, czy masz otwartą sesję<br/><br/>" +
                '<b>Moduł LMRA jest zablokowany: nie można rozpocząć ani zamknąć sesji. </b><br/> Jednak nadal możesz wysyłać raporty o incydentach (poza sesją)<br/>' +
                'Otrzymasz powiadomienie, gdy usługa sesji będzie dostępna<br/><br/>' +
                "jeśli ten błąd będzie się powtarzał, powiadom administratora..."
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Przepraszamy: <b>Moduł LMRA jest obecnie zablokowany: nie można rozpocząć ani zamknąć sesji.</b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'Odpowiedź serwera nie zawiera danych sesji',
                    could_not_save_session : 'Nie można zapisać danych sesji lokalnie...',
                    invalid_session_data : 'Dane sesji są nieprawidłowe, dane mogą być uszkodzone'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Wystąpił nieznany błąd",
            notFound : "Nie znaleziono kodu grupy."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Domyślny numer alarmowy",
        getting_data_title: "Pobieranie najnowszych numerów"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Aktywna lista",
                other_checklists : "Inne listy"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Oglądanie : "
            },
            warning_message : "Oglądasz listę kontrolną, która nie jest aktualnie aktywną listą. Aby wyświetlić aktywną listę, użyj zakładki \"Aktywna lista kontrolna\" u góry"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "Wersja jest aktualna",
            version_minor_update : "Dostępna nowsza wersja (może nie być dostępna dla Twojego najemcy)",
            update_required : "Ostrzeżenie! Ta aplikacja jest nieaktualna, powinna zostać zaktualizowana automatycznie. Jeśli ten komunikat będzie się powtarzał, skontaktuj się z administratorem."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Zły typ kodu QR",
                    body : "Ten typ kodu QR nie jest tutaj obsługiwany"
                },
                wrong_tenant : {
                    title : "Niewłaściwy najemca",
                    body : "Twoja firma nie może używać tego kodu QR"
                },
                invalid_qr_code : {
                    title : "Nieprawidłowy kod QR",
                    body : "To nie jest prawidłowy kod QR Risk Reflex i nie można go użyć"
                },
                invalid_qr_data : {
                    title : "Nieprawidłowe dane kodu QR",
                    body : "Tego kodu QR nie można przetłumaczyć, kod QR może być uszkodzony"
                }
            },
            title : "Zeskanuj kod QR Risk-Reflex",
            manual: 'Masz problemy ze skanowaniem? Użyj wprowadzania ręcznego ',
            manual_btn: "Przełącz na tryb ręczny"
        }
    }
}